import { cva } from 'class-variance-authority';

var clazzContainer = cva("w-min h-fit inline-flex flex-col", {
    variants: {},
    defaultVariants: {}
});
var clazz = cva([
    "grid items-center justify-between w-fit h-fit rounded-lg",
    "border border-gray-204 p-[1px]",
    "hover:border hover:border-brand hover:p-[1px]",
    "focus-within:border-2 focus-within:border-brand focus-within:p-0",
    "hover:focus-within:border-2 hover:focus-within:border-brand hover:focus-within:p-0",
], {
    variants: {
        error: {
            true: [
                "border border-error p-[1px]",
                "hover:border hover:border-error hover:p-[1px]",
                "focus-within:border-2 focus-within:border-error focus-within:p-0",
                "hover:focus-within:border-2 hover:focus-within:border-error hover:focus-within:p-0",
            ]
        },
        hasAdornment: { false: "", true: "grid-cols-[min-content_minmax(0,1fr)]" },
        hasAdornments: { false: "", true: "grid-cols-[min-content_min-content_minmax(0,1fr)]" },
        hasAppendage: { false: "", true: "grid-cols-[minmax(0,1fr)_min-content]" },
        hasAppendages: { false: "", true: "grid-cols-[minmax(0,1fr)_min-content_min-content]" },
        disabled: { true: "pointer-events-none border border-gray-204 p-[1px]" },
    },
    compoundVariants: [
        {
            hasAdornment: true,
            hasAppendage: true,
            className: "grid-cols-[min-content_minmax(0,1fr)_min-content]"
        },
        {
            hasAdornment: false,
            hasAppendage: false,
            className: "grid-cols-[minmax(0,1fr)]"
        },
        {
            hasAdornment: true,
            hasAppendages: true,
            className: "grid-cols-[min-content_minmax(0,1fr)_min-content_min-content]"
        },
        {
            hasAdornments: true,
            hasAppendage: true,
            className: "grid-cols-[min-content_min-content_minmax(0,1fr)_min-content]"
        },
        {
            hasAdornments: true,
            hasAppendages: true,
            className: "grid-cols-[min-content_min-content_minmax(0,1fr)_min-content_min-content]"
        },
    ],
    defaultVariants: {}
});
var clazzInput = cva("flex-grow bg-transparent text-dark-text ring-0 border-0 outline-0 placeholder:select-none placeholder:text-base placeholder:w-fit placeholder:leading-4 placeholder:text-light-text", {
    variants: {
        before: { false: "", true: "" },
        after: { false: "", true: "" },
        prefix: { false: "", true: "" },
        suffix: { false: "", true: "" },
        disabled: { true: "text-disabled-text placeholder:text-disabled-text" },
        size: {
            sm: "h-[28px]",
            md: "h-[36px]",
        }
    },
    compoundVariants: [
        {
            before: false,
            prefix: false,
            className: "ml-3"
        },
        {
            prefix: true,
            className: "ml-1"
        },
        {
            after: false,
            suffix: false,
            className: "mr-3"
        },
        {
            suffix: true,
            className: "mr-1"
        }
    ],
    defaultVariants: {
        size: "md"
    }
});
var clazzSlot = cva("flex items-center max-w-min flex-shrink-0 justify-center overflow-hidden", {
    variants: {
        size: {
            sm: "w-6 h-6",
            md: "w-8 h-8",
        },
        position: {
            left: "ml-1",
            right: "mr-1"
        }
    },
    defaultVariants: {
        size: "md"
    }
});
var clazzAffix = cva("flex items-center max-w-min flex-shrink-0 justify-center w-fit select-none text-light-text", {
    variants: {
        before: { false: "", true: "" },
        after: { false: "", true: "" },
        prefix: { false: "", true: "" },
        suffix: { false: "", true: "" },
        position: { left: "", right: "" },
        disabled: { true: "text-disabled-text" },
    },
    compoundVariants: [
        {
            before: false,
            position: "left",
            className: "ml-3"
        },
        {
            after: false,
            position: "right",
            className: "mr-3"
        }
    ],
    defaultVariants: {}
});
var clazzLabel = cva("block h-fit mb-1 text-base leading-5 text-dark-text", {
    variants: {
        disabled: { true: "text-disabled-text select-none" }
    },
    defaultVariants: {}
});
var clazzSubLabel = cva("block h-fit mt-1 text-sm leading-4 text-light-text", {
    variants: {
        error: { true: "text-error" },
        disabled: { true: "text-disabled-text select-none" }
    },
    defaultVariants: {}
});

export { clazz, clazzAffix, clazzContainer, clazzInput, clazzLabel, clazzSlot, clazzSubLabel };
